export default __webpack_public_path__ + "static/media/recharge-icon.34bf9245.svg";